"use client"

import { useEffect, useRef, useState, useCallback } from "react"
import Script from "next/script"


interface TurnstileProps {
  siteKey: string
  onVerify?: (token: string) => void
  onError?: () => void
  onExpire?: () => void
}

declare global {
  interface Window {
    turnstile?: {
      render: (element: HTMLElement, options: any) => string
      reset: (widgetId: string) => void
      remove: (widgetId: string) => void
    }
  }
}


export default function Turnstile(props: TurnstileProps) {
  const { siteKey, onVerify, onError, onExpire } = props;
  console.log(`[Turnstile] siteKey: ${siteKey}`)
  const ref = useRef<HTMLDivElement>(null)
  const widgetId = useRef<string | null>(null)
  const [scriptLoaded, setScriptLoaded] = useState(false)

  const handleVerify = useCallback((token: string) => {
    onVerify?.(token)
  }, [onVerify])

  const handleError = useCallback(() => {
    onError?.()
  }, [onError])

  const handleExpire = useCallback(() => {
    onExpire?.()
  }, [onExpire])

  useEffect(() => {
    if (!scriptLoaded || !ref.current || widgetId.current) return;

    console.log("🛠 Rendering Turnstile...");
    if(ref.current) {
    widgetId.current = window.turnstile!.render(ref.current, {
      sitekey: siteKey,
      callback: (token: string) => {
        console.log("✅ onVerify called:", token);
        handleVerify(token);
      },
      "error-callback": handleError,
      "expired-callback": handleExpire,
      theme: "light",
      size: "normal",
    });
    console.log(`widgetId: ${widgetId.current}`)
    }
    return () => {
      if (widgetId.current && window.turnstile) {
        console.log("🧹 Removing Turnstile...");
        window.turnstile.remove(widgetId.current);
        widgetId.current = null;
        ref.current = null;

      }
    };
  }, [ scriptLoaded]);
  
  return (
    <>
      <Script
        src="https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit"
        async
        defer
        onLoad={() => setScriptLoaded(true)}
      />
      <div ref={ref} className="cf-turnstile" />
    </>
  )
}
